var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2929 1.29289C11.6834 0.902369 12.3166 0.902369 12.7071 1.29289L14.7071 3.29289C15.0976 3.68342 15.0976 4.31658 14.7071 4.70711L8.70712 10.7071C8.59734 10.8169 8.46352 10.8996 8.31624 10.9487L5.31624 11.9487C4.9569 12.0685 4.56074 11.9749 4.2929 11.7071C4.02507 11.4393 3.93155 11.0431 4.05133 10.6838L5.05133 7.68377C5.10042 7.53649 5.18313 7.40267 5.2929 7.29289L9.28996 3.29584L9.29289 3.29289L9.29584 3.28996L11.2929 1.29289ZM12.5858 4L12 4.58579L11.4142 4.00001L12 3.41421L12.5858 4ZM10.5858 6.00001L10 5.41422L6.87404 8.54018L6.58115 9.41886L7.45983 9.12597L10.5858 6.00001Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.59998C3 4.26861 3.26863 3.99998 3.6 3.99998H6C6.55228 3.99998 7 3.55226 7 2.99998C7 2.44769 6.55228 1.99998 6 1.99998H3.6C2.16406 1.99998 0.999998 3.16404 1 4.59998L1.00001 12.4C1.00001 13.8359 2.16407 15 3.60001 15H11.4C12.8359 15 14 13.8359 14 12.4V8.99998C14 8.44769 13.5523 7.99998 13 7.99998C12.4477 7.99998 12 8.44769 12 8.99998V12.4C12 12.7314 11.7314 13 11.4 13H3.60001C3.26864 13 3.00001 12.7314 3.00001 12.4L3 4.59998Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite);
export default __webpack_public_path__ + "static/media/write.8ab5d42b.svg";
export { ForwardRef as ReactComponent };